module.exports = __webpack_public_path__ + "static/flow2-a2150589e265d01c62d1b664267716b3.svg";